import SuiBox from "components/SuiBox";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import OrganizationDetails from "../components/organization-details";

const EditOrganization = ({ organization, redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/organization/edit") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <OrganizationDetails organization={organization} />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

EditOrganization.defaultProps = {
  organization: null,
  redirectTo: "",
};

EditOrganization.propTypes = {
  organization: PropTypes.objectOf(PropTypes.any),
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state, { location }) => {
  const targetId = location.state?.organizationId;
  const allOrganizations = state?.data?.organizations
    ? Object.values(state?.data?.organizations)
    : [];
  const foundOrganization = allOrganizations.find((organization) => organization.id === targetId);

  return {
    organization: foundOrganization,
    redirectTo: state.ui.redirectTo,
  };
};

export default connect(mapStateToProps, null)(EditOrganization);
